import png1 from "./1.jpg";
import png2 from "./2.jpg";
export const gpnjyh = [
  {
    name: "查找流水",
    msgList: [
      { msg: "登录南京银行APP，搜索【流水明细打印】或【历史明细】" },
      { imgs: [png1, png2] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
      { msg: "选择时间范围【近一年】，填写专属邮箱并发送" },
      // { imgs: [png3, png4, png5] },
    ],
  },
  {
    name: "注意事项",
    msgList: [{ msg: "请确认账期覆盖近12个月，并开启明细文件加密" }],
  },
];
